import type { SimilarShowcases } from './similar-showcases.model';
import type { Skill } from '../skills/skills.model';
import { phpSkill } from '../skills/skills.seed';

export interface GenerateSimilarShowcasesOptions {
  readonly userId: number;
  readonly skills?: readonly Skill[];
}

export function generateSimilarShowcasesObject({
  userId,
  skills = [phpSkill()],
}: GenerateSimilarShowcasesOptions): SimilarShowcases {
  return {
    id: userId,
    tags: skills.map(skill => ({
      url: `/showcase/s/${skill.name}`,
      label: skill.name,
    })),
  };
}
